import { FormActions } from "../../components/common/FormActions";
import { IFormSection, TFormHookParams } from "../../types/common";
import { API_ASSET_CATEGORIES } from "../../utils/apis";
import { CAN_CONFIGURE_ASSET_SYSTEM } from "../../utils/constants";
import {
  createDeleteAction,
  createViewEdit,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_ASSET_CATEGORIES } from "../../utils/urls";
import { auditFields, useAssetPermissions } from "./assetUtils";

export const useAssetCategories = () => {
  const can = useAssetPermissions();
  const canConfigure = can(CAN_CONFIGURE_ASSET_SYSTEM);

  const tableColumns = () => [
    { id: "name", header: "Name" },
    { id: "description", header: "Description" },
    { id: "created_by", header: "Created By" },
    { id: "created_at", header: "Created At" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any[]) =>
    data?.map((item: any) => ({
      ...item,
      ...auditFields(item),
      actions: (
        <FormActions
          actions={[
            ...createViewEdit(URL_ASSET_CATEGORIES, item?.id, canConfigure),
            ...(canConfigure
              ? [
                  createDeleteAction(
                    `${API_ASSET_CATEGORIES}${item?.id}/`,
                    item?.name,
                  ),
                ]
              : []),
          ]}
        />
      ),
    }));

  const viewData = (item: any) => ({
    sections: [
      {
        title: "Category Details",
        fields: {
          name: item?.name,
          description: item?.description,
          ...auditFields(item),
        },
      },
    ],
  });

  return {
    tableTitle: "Asset Categories",
    tableColumns,
    tableData,
    viewData,
    formRoute: canConfigure ? getForm(URL_ASSET_CATEGORIES) : undefined,
    createTitle: "New Asset Category",
  };
};

export const useAssetCategoriesForm = ({ id }: TFormHookParams = {}) => {
  const sections: IFormSection[] = [
    {
      title: "Category Details",
      fields: [
        {
          field_name: "name",
          label: "Name",
          type: "text",
          props: { required: !id, placeholder: "e.g. Electronics" },
        },
        {
          field_name: "description",
          label: "Description",
          type: "textarea",
          props: { placeholder: "Optional description" },
        },
      ],
    },
  ];

  const onSubmit = (payload: any) => ({
    ...(id ? { id } : {}),
    api: API_ASSET_CATEGORIES,
    params: { name: payload?.name, description: payload?.description },
  });

  return {
    sections,
    title: "Asset Category",
    redirect: getRegister(URL_ASSET_CATEGORIES),
    onSubmit,
  };
};
